<template>
  <div class="ma-2">
    <v-data-table
      :headers="headers"
      :items="itens"
      :options.sync="options"
      :server-items-length="totalItens"
      :loading="loading"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 25, 50, 100],
        showFirstLastPage: true,
        itemsPerPageText: 'Itens por página',
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus'
      }"
      @page-count="pageCount = $event">
        <template v-slot:top>
          <v-form @submit="pesquisar()" v-on:submit.prevent>
            <v-container fluid>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-select clearable v-model="pesquisa.cc_fil" label="Empresa" placeholder="" :items="filiais" item-text="cc_fil" item-value="cc_fil"></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-text-field clearable v-model="pesquisa.dt_fat_i_formatada" v-mask="mascaraData" label="Data início" placeholder="" @blur="pesquisa.dt_fat_i = parseDate(pesquisa.dt_fat_i_formatada)"></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-text-field clearable v-model="pesquisa.dt_fat_f_formatada" v-mask="mascaraData" label="Data fim" placeholder="" @blur="pesquisa.dt_fat_f = parseDate(pesquisa.dt_fat_f_formatada)"></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-checkbox v-model="pesquisa.bl_sin_man" label="Não sincronizados" value="false"></v-checkbox>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                  <v-btn depressed outlined type="submit" color="primary">
                    pesquisar
                  </v-btn>&nbsp;
                  <v-btn depressed outlined @click="downloadXml()" :disabled="pesquisa.cc_fil === undefined || (pesquisa.dt_fat_i_formatada === undefined || pesquisa.dt_fat_i_formatada === null || pesquisa.dt_fat_i_formatada === '') || (pesquisa.dt_fat_f_formatada === undefined || pesquisa.dt_fat_f_formatada === null || pesquisa.dt_fat_f_formatada === '') ">
                    fazer download do xml
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </template>
        <template v-slot:item.vl_fat="{ item }">
            {{ moeda(item.vl_fat) }}
        </template>
        <template v-slot:item.tx_fat_dt_emi="{ item }">
            {{ getDataEmissao(item) }}
        </template>
        <template v-slot:item.tx_fat_key="{ item }">
            {{ formatarChaveDeAcessoNfe(item.tx_fat_key) }}
        </template>
        <template v-slot:item.tx_fat_num_doc="{ item }">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-chip v-on="on" :color="(item.tx_fat_num_ptc_can !== '') ? 'error' : 'primary'">{{item.tx_fat_num_doc}}</v-chip>
            </template>
            <span>{{ (item.tx_fat_num_ptc_can !== '') ? 'Cancelado' : 'Autorizado' }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.cliente="{ item }">
            {{(item.cliente != undefined) ? item.cliente.cc_cli_ins_fed : ''}}
            <span v-if="item.cliente === undefined">-</span>
        </template>
        <template v-slot:item.action="{ item }">
          <v-tooltip left>
            <template v-slot:activator="{ on }" v-if="item.tx_fat_num_ptc === ''">
                <v-btn depressed small fab color="primary" v-on="on" @click="emitir(item)" class="mr-1">
                  <v-icon>mdi-arrow-up-bold</v-icon>
                </v-btn>
            </template>
            <span>Emitir pra SEFAZ</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-btn depressed small fab color="primary" v-on="on" @click="downloadXMLItem(item)" class="mr-1">
                  <v-icon>mdi-file-download</v-icon>
                </v-btn>
            </template>
            <span>Fazer download do XML</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-btn depressed small fab color="primary" v-on="on" @click="ver(item)" class="mr-1">
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
            </template>
            <span>Ver</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-btn depressed small fab v-on="on" :color="`${item.bl_sin_man ? 'primary' : '#E8F5E9'}`" @click="tratarSincronia(item)">
                  <v-icon>mdi-sync-circle</v-icon>
                </v-btn>
            </template>
            <span>{{ `${item.bl_sin_man ? 'Desmarcar sincronizado' : 'Marcar como sincronizado'}` }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-divider></v-divider>

      <v-card>

        <v-toolbar flat color="accent">
          <v-toolbar-title>Inutiliza&ccedil;&atilde;o de N&uacute;meros</v-toolbar-title>
        </v-toolbar>

        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Empresa</th>
                <th class="text-left">Ano</th>
                <th class="text-left">S&eacute;rie</th>
                <th class="text-left">N&uacute;mero inicial</th>
                <th class="text-left">N&uacute;mero final</th>
                <th class="text-left">Protocolo</th>
                <th class="text-left">Data</th>
              </tr>
            </thead>
            <tbody v-if="inutilizados.length == 0">
              <tr>
                <td colspan="7">
                  <v-alert text type="info" color="primary">N&atilde;o h&aacute; n&uacute;meros inutilizados</v-alert>
                </td></tr>
            </tbody>
            <tbody v-if="inutilizados.length > 0">
              <tr v-for="item in inutilizados" :key="item.id_reg">
                <td>{{ item.cc_fil }}</td>
                <td>{{ item.cn_ano }}</td>
                <td>{{ item.cn_ser}}</td>
                <td>{{ item.cn_num_ini}}</td>
                <td>{{ item.cn_num_fim}}</td>
                <td>{{ item.cc_pro}}</td>
                <td>{{ formatDate2(item.dt_inu)}}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <v-form v-on:submit.prevent>
          <v-container fluid>
            <v-row>
              <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                <v-select clearable v-model="inutilizado.cc_fil" label="Empresa" :items="filiais" item-text="cc_fil" item-value="cc_fil"></v-select>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="1" lg="1" xl="1">
                <v-select clearable v-model="inutilizado.cn_ano" label="Ano" :items="anos" item-text="nm_ano" item-value="cc_ano"></v-select>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="1" lg="1" xl="1">
                <v-text-field type="number" label="Série" v-model="inutilizado.cn_ser"></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="1" lg="1" xl="1">
                <v-text-field type="number" label="Número inicial" v-model="inutilizado.cn_num_ini"></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="1" lg="1" xl="1">
                <v-text-field type="number" label="Número final" v-model="inutilizado.cn_num_fim"></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <v-text-field label="Justificativa" v-model="inutilizado.tx_jus"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <v-btn depressed outlined color="primary" @click="inutilizar()">
                  inutilizar
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card>
      <v-dialog v-model="dialog" persistent max-width="500" scrollable :key="idModal">
        <v-card>
          <v-card-title>
            Detalhes da NFC-e
          </v-card-title>
          <v-card-text class="pt-2">

            <v-alert border="right" colored-border type="error" elevation="2" v-if="itemSelecionado.tx_fat_num_ptc_can !== ''">
              Esta NFC-e foi cancelada!<br/>
              Protocolo: <span class="font-weight-bold">{{ itemSelecionado.tx_fat_num_ptc_can }}</span>
            </v-alert>

            <div class="d-flex justify-center ma-5">
              <span class="font-weight-bold">{{ formatarChaveDeAcessoNfe(itemSelecionado.tx_fat_key)  }}</span>
            </div>
            
            <div class="d-flex justify-center ma-5">
              Protocolo: <span class="font-weight-bold">{{ itemSelecionado.tx_fat_num_ptc }}</span>
            </div>

            <v-card class="mb-2">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Número</th>
                      <th>Valor</th>
                      <th>Data</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ itemSelecionado.tx_fat_num_doc }}</td>
                      <td>{{ moeda(itemSelecionado.vl_fat) }}</td>
                      <td>{{ formatDate(itemSelecionado.dt_fat) }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>

            <v-card v-if="itemSelecionado.cliente != undefined" class="mb-2">
              <v-simple-table>
                <thead>
                  <tr>
                    <th>CPF</th>
                    <th>Nome</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ itemSelecionado.cliente.cc_cli_ins_fed }}</td>
                    <td>{{ itemSelecionado.cliente.nm_cli }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card>

            <v-card class="mb-2" v-if="itemSelecionado.pagamentos != undefined && itemSelecionado.pagamentos.length > 0">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Tipo</th>
                      <th>Valor</th>
                      <th>Parcelas</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item  in itemSelecionado.pagamentos" :key="item.id_reg">
                      <td>{{ item.ds_pgt }}</td>
                      <td>{{ moeda(item.vl_pgt) }}</td>
                      <td>{{ item.cc_prz }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>

            <v-card class="mb-2">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Código</th>
                      <th align="right" width="40">Vl. Unitário</th>
                      <th align="right" width="40">QTD</th>
                      <th align="right" width="40">Desc</th>
                      <th align="right">Valor</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item  in itemSelecionado.itens" :key="item.id_reg">
                      <td>{{ item.cc_psr }}</td>
                      <td align="right">{{ moeda(item.vl_fat_ite_uni) }}</td>
                      <td align="right">{{ item.qt_fat_ite }}</td>
                      <td align="right">{{ moeda(item.vl_fat_ite_des) }}</td>
                      <td align="right">{{ moeda(item.vl_fat_ite_tot) }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>

            <!--v-card flat class="mt-2">
                <v-btn block>
                  Fazer Download do XML
                  <v-icon right @click="fazerDownloadItem()">mdi-file-download</v-icon>
                </v-btn>
            </v-card-->

          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed @click="dialog = false">
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
</template>
<script>
  import lodash from 'lodash'
  import { moeda } from '../../utils.js'
  export default {
    name: 'NFCE',
    data () {
      return {

        /** atributos da paginacao */
        page: 1,
        pageCount: 0,
        itemsPerPage: 10,
        totalItens: 0,
        itens: [],
        loading: true,
        options: {},
        headers: [
          { text: 'Empresa', value: 'cc_fil', sortable:false, width: 70 },
          { text: 'Emissão', value: 'tx_fat_dt_emi', sortable:false, width:80},
          { text: 'Cliente', value: 'cliente', sortable:false, width: 80 },
          { text: 'Valor', value: 'vl_fat', sortable:false, width:70, align: 'right'},
          { text: 'Número', value: 'tx_fat_num_doc', sortable:false, width:100 },
          { text: 'Pedido', value: 'cc_ped', sortable:false, width:200 },
          { text: 'Chave', value: 'tx_fat_key', sortable:false },
          { text: 'Protocolo', value: 'tx_fat_num_ptc', sortable:false, width: 90 },
          { text: '', value: 'action', sortable:false, width: 210, align: 'right' },
        ],

        /** atributos da pesquisa*/
        pesquisa: {
          cc_fil: undefined,
          dt_fat_i: undefined,
          dt_fat_i_formatada: undefined,
          dt_fat_f: undefined,
          dt_fat_f_formatada: undefined,
          bl_sin_man: undefined
        },
        mascaraData: '##/##/####',

        filiais: [],

        /** atributos da visualização do item */
        dialog: false,
        itemSelecionado: {},
        idModal: 1,

        /** INUTILIZACAO */
        anos:[],
        inutilizados: [],
        inutilizado: {
          cc_fil: undefined,
          cn_ano: undefined,
          cn_ser: undefined,
          cn_num_ini: undefined,
          cn_num_fim: undefined,
          tx_jus: undefined
        },
        pesquisa_inutilizacao: {
          cc_fil: undefined
        }

      }
    },

    watch: {
      options: {
        handler () {
          this.getDataFromApi()
            .then(data => {
              this.itens = data.items
              this.totalItens = data.total
              this.pageCount = data.totalPages
            })
        },
        deep: true,
      },
      /*
      itemSelecionado : {
        handler(){
          this.dialog = true
        }
      },
      */
    },

    mounted () {
      
      this.getDataFromApi()
        .then(data => {
          this.itens = data.items
          this.totalItens = data.total
        })

      this.populaFiliais()

      const currentYear  = new Date().getFullYear()
      for(let i = currentYear; i >= currentYear - 10; i--){
        this.anos.push({cc_ano: (i + "").substring(2,4), nm_ano: i + ""})
      }

      this.pesquisarInutilizados()

    },

created(){
      this.$vuetify.goTo(0)
    },
    
    methods: {

      pesquisar() { 
        this.page = 1
        this.getDataFromApi()
          .then(data => {
            this.itens = data.items
            this.totalItens = data.total
          })
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDate2 (date) {
        if (!date) return null

        const [d, h] = date.split('T')
        const [year, month, day] = d.split('-')
        return `${day}/${month}/${year} ${h}`
      },

      parseDate (date) {
        if (!date) return null

        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },


      populaFiliais() {
        this.$store.dispatch('obterFiliais', {}).then(resp => {
          this.filiais = resp.data.content
        }).catch(err => {
          console.log(err)
        })
      },

      getDataEmissao(item) { 
        let dataArr = item.dt_fat.split('-')
        return `${dataArr[2]}/${dataArr[1]}/${dataArr[0]}`
      },

      ver(item) {
        this.idModal = Math.random(1000)
        this.itemSelecionado = item
        this.dialog = true
      },

      formatarChaveDeAcessoNfe(chave){

        if (chave !== undefined) {
          if (chave.length === 47) {
            chave = chave.substring(3)
          }
          if (chave.length !== 44) {
            return chave;
          } else {
            return chave.split("").reduceRight(function(elemento, anterior){
              var temp = anterior + elemento;
              if(temp.replace(/\s/g, "").length % 4 === 0) return " " + temp;
              else return temp;
            });
          }
        } else {
          return ''
        }
      },

      downloadXMLItem(item) {
         this.$store.dispatch('fazerDownloadXMLNFCEIndividual', item.id_reg).then((resp) => {

          var fileURL = window.URL.createObjectURL(new Blob([resp.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', `NFCe_${item.tx_fat_key}.zip`);
          document.body.appendChild(fileLink);
          fileLink.click();
          fileLink.remove();

        }).catch(err => {
          console.log(err)
        })
      },

      downloadXml(){
        this.$store.dispatch('fazerDownloadXMLNFCE', this.pesquisa).then((resp) => {

          var fileURL = window.URL.createObjectURL(new Blob([resp.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', `NFCe_${this.pesquisa.cc_fil}_${this.pesquisa.dt_fat_i}_${this.pesquisa.dt_fat_f}_.zip`);
          document.body.appendChild(fileLink);
          fileLink.click();
          fileLink.remove();

        }).catch(err => {
          console.log(err)
        })
      },

      tratarSincronia(item) {
        this.$store.dispatch(item.bl_sin_man ? 'anularRecebimento' : 'marcarComoRecebido', item).then(() => {
          item.bl_sin_man = !item.bl_sin_man
        }).catch(err => {
          console.log(err)
        })
      },

      moeda(valor){
        return moeda(valor)
      },

      getDataFromApi () {

        this.loading = true

        // eslint-disable-next-line no-unused-vars
        return new Promise((resolve, reject) => {

          // eslint-disable-next-line no-unused-vars
          const { sortBy, sortDesc, page, itemsPerPage } = this.options

          let params = {
            page: page-1,
            size: itemsPerPage === -1 ? 999999999 : itemsPerPage
          };

          let filtro = lodash.omitBy(Object.assign(params, this.pesquisa), o => !o)

          this.$store.dispatch('pesquisaFaturaNFCE', filtro).then( resp => {

            this.loading = false

            let items        = resp.data.content
            const total      = resp.data.totalElements
            const totalPages = resp.data.totalElements

            resolve( { items, total, totalPages } )

          }).catch( err => {
            console.log(err)
          })

        })
      },

      emitir(item) {
        this.$store.dispatch('emitirNFCeOffLine', item).then(resp => {
          item.tx_fat_num_ptc = resp.data.protocolo
          this.itens.filter(e => e.id_reg === item.id_reg)[0].tx_fat_num_ptc = resp.data.protocolo
        }).catch(err => {
          console.log(err)
        })
      },

      limparFormularioInutilizacao(){
        this.inutilizado = {}
      },

      inutilizar() { 
        if (this.inutilizado.cc_fil !== undefined && this.inutilizado.cc_fil.length > 0) { 
          if (this.inutilizado.cn_ano !== undefined && this.inutilizado.cn_ano.length > 0) { 
            if (this.inutilizado.cn_ser !== undefined && this.inutilizado.cn_ser.length > 0) { 
              if (this.inutilizado.cn_num_ini !== undefined && this.inutilizado.cn_num_ini.length > 0) { 
                if (this.inutilizado.cn_num_fim !== undefined && this.inutilizado.cn_num_fim.length > 0) { 
                  if( parseInt(this.inutilizado.cn_num_ini) <= parseInt(this.inutilizado.cn_num_fim) ){
                    if (this.inutilizado.tx_jus !== undefined && this.inutilizado.tx_jus.length >= 15) { 
                      this.loading = true
                      this.$store.dispatch('inutilizarNumeroNFCe', this.inutilizado).then(() => {
                        // atualizar lista de inutilizados
                        this.loading = false
                        this.pesquisarInutilizados()
                        this.limparFormularioInutilizacao()
                      }).catch(() => {
                        
                        //console.log(err)
                      }).finally(() => { 
                        this.loading = false
                      })

                    } else {
                      alert("ol")
                    }
                  }else{
                    alert("numero inicial nao pode ser maior que o numero final")
                  }
                }
              }
            }
          }

        }
      },

      pesquisarInutilizados() {
        this.$store.dispatch('pesquisarNumerosInutilizadosNFCe').then(resp => {
          this.inutilizados = resp.data
        }).catch(err => {
          console.log(err)
        })
      },

    },
  }
</script>